import React from 'react';
import { useHistory } from 'react-router-dom';
import { AppBar, Button, createStyles, Icon, makeStyles, Toolbar } from '@material-ui/core';

import SwipeableMenu from './Menu';
import LogoBCW from '../../../assets/bcw_logo.png';
import { AuthContext } from '../../Authentication/AuthContext';



const useStyles = makeStyles(() => createStyles({
    appbar: {
        zIndex: 1111,
    },
    exitButton: {
        marginRight: 0,
        color: '#FFFFFF',
    },
    img: {
        flexGrow: 1,
        textAlign: 'center'
    },
    logout: {
        marginLeft: '8px',
        fontSize: '16px !important'
    }
}));

export function Header() {
    const classes = useStyles();

    const auth = React.useContext(AuthContext);

    const history = useHistory();

    const [openMenu, setOpenMenu] = React.useState<boolean>(false);

    const logout = () => {
        auth.signout(() => {
            const loginOrigin = localStorage.getItem('loginOrigin');
            localStorage.removeItem('loginOrigin');
            if (loginOrigin === 'boticario') {
                history.push('/boticario/login');
            } else {
                history.push('/');
            }
        });
    };

    return (
        <AppBar position="fixed" color="primary" elevation={4} className={classes.appbar}>
            <Toolbar color="primary">
                <SwipeableMenu
                    open={openMenu}
                    setOpen={setOpenMenu} />
                <div className={classes.img}>
                    <img src={LogoBCW} alt="" height={33} />
                </div>
                <Button
                    className={classes.exitButton}
                    endIcon={<Icon className={classes.logout}>logout</Icon>}
                    onClick={logout}>
                    SAIR
                </Button>
            </Toolbar>
        </AppBar>
    );
}